import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfoTooltipComponent } from '@ui-kit/miscs/info-tooltip/info-tooltip.component';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
@Component({
    selector: 'checkbox-fc',
    standalone: true,
    imports: [CheckboxModule, TranslateModule, ReactiveFormsModule, TooltipModule, InfoTooltipComponent],
    templateUrl: './checkbox-fc.component.html',
    styleUrl: './checkbox-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFcComponent {
    id = input.required<string>();
    control = input.required<FormControl>();

    label = input<string>('');
    checkboxTooltip = input<string>('');
    tooltipText = input<string>('');

    required = input<boolean>(false);
    binary = input<boolean>(true);

    flexStartAlignment = input<boolean>(false);
    centerAlignment = input<boolean>(false);
    boldLabel = input<boolean>(false);
    class = input<string>('');

    onChange = output<CheckboxChangeEvent>();
}
